import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { Identifier } from '../../../../types/types';

@Component({
    selector: 'app-category-path-component',
    template: `
    <!-- prettier-ignore -->
    <span class="ui-grid-cell-contents">
      <span class="category-name" data-test-selector="category-name">
      @if(categories){
        @for(category of categories; track category; let index=$index, first=$first,last=$last) {
            @if(last) { {{category.name}} }
            @else if (categories.length === 1) { {{category.name}} }
            @else if(first) {}
            @else {
              <span>{{category.name}}</span>
              <span class="m-1"> &#8226;</span>
            }
        }
      }
      </span>
    </span>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CategoryPathCellRendererComponent {
  @Input() categories?: Identifier[];

  constructor() {}

  refresh(): boolean {
    return false;
  }
}
